// src/components/sports/MatchCard.jsx
import React from 'react';
import BetButton from '../common/BetButton';

const MatchCard = ({ match, sport, oddsFormat, onAddToBetslip, viewMode = 'grid' }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      weekday: 'short', 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const isCompact = viewMode === 'grid';

  return (
    <div className={`bg-gray-900 rounded-xl hover:bg-gray-800 transition-colors duration-200 ${
      isCompact ? 'p-3 sm:p-4' : 'p-4 sm:p-6'
    }`}>
      {/* Match Header */}
      <div className="flex justify-between items-center mb-3">
        <div className="text-xs text-gray-400 truncate">{match.league || match.tournament}</div>
        <div className="text-xs text-gray-400 whitespace-nowrap">
          {formatDate(match.startTime)}
        </div>
      </div>
      
      {/* Teams */}
      <div className="flex justify-between items-center mb-4">
        <div className={`font-medium text-white truncate ${isCompact ? 'text-sm' : 'text-base'}`}>
          {match.homeTeam || match.player1}
        </div>
        <div className={`px-2 text-gray-400 ${isCompact ? 'text-xs' : 'text-sm'}`}>VS</div>
        <div className={`font-medium text-white truncate text-right ${isCompact ? 'text-sm' : 'text-base'}`}>
          {match.awayTeam || match.player2}
        </div>
      </div>
      
      {/* Betting Odds */}
      <div className="flex space-x-1 sm:space-x-2">
        {/* Home/Player 1 Odds */}
        <BetButton
          odds={match.odds.home || match.odds.player1}
          selection={match.odds.home ? "1" : "P1"}
          match={`${match.homeTeam || match.player1} vs ${match.awayTeam || match.player2}`}
          matchId={match.id}
          sport={sport}
          type="home"
          isCompact={isCompact}
        />
        
        {/* Draw Odds (if exists) */}
        {match.odds.draw && (
          <BetButton
            odds={match.odds.draw}
            selection="X"
            match={`${match.homeTeam || match.player1} vs ${match.awayTeam || match.player2}`}
            matchId={match.id}
            sport={sport}
            type="draw"
            isCompact={isCompact}
          />
        )}
        
        {/* Away/Player 2 Odds */}
        <BetButton
          odds={match.odds.away || match.odds.player2}
          selection={match.odds.away ? "2" : "P2"}
          match={`${match.homeTeam || match.player1} vs ${match.awayTeam || match.player2}`}
          matchId={match.id}
          sport={sport}
          type="away"
          isCompact={isCompact}
        />
      </div>
      
      {/* Additional Markets - Hidden in compact view */}
      {!isCompact && match.additionalMarkets && (
        <div className="mt-4 pt-3 border-t border-gray-800">
          <div className="flex flex-wrap gap-2">
            {match.additionalMarkets.map((market, index) => (
              <button
                key={index}
                className="px-3 py-1.5 bg-gray-800 hover:bg-gray-700 rounded text-xs text-gray-300 transition-colors"
                onClick={() => {
                  // Handle additional market selection
                  console.log('Additional market:', market);
                }}
              >
                {market.name}: {market.odds}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MatchCard;